export default {
    cta: "Zapytaj An<br/> Doradca",
    ordered: "Zamówiono w dniu {date}"
}